import { ExtractedValuesByKey } from '../../../models/extracted-values';

export class EseFormValidator {
  constructor(private readonly val: ExtractedValuesByKey) {}

  eseAuftragsformValid(): boolean {
    if (!this.val['ese_betroffene_person_vorname'] || !this.val['ese_betroffene_person_nachname']) {
      return false;
    }

    if (this.hasAtLeastOneField('ese_anwalt_')) {
      return this.anwaltCaseValid();
    }

    if (this.hasAtLeastOneField('ese_vertretungsberechtigte_person_')) {
      return this.vertretungsberechtigterCaseValid();
    }

    return (
      !!this.val['ese_betroffene_person_email'] || this.hasAddressFilled('ese_betroffene_person_')
    );
  }

  private anwaltCaseValid(): boolean {
    if (!this.val['ese_anwalt_nachname'] || !this.val['ese_anwalt_fallnummer']) {
      return false;
    }

    if (this.val['ese_anwalt_email']) {
      if (
        this.hasAtLeastOneField('ese_vertretungsberechtigte_person_') &&
        !this.allVertretungsberechtigteFieldsFilled()
      ) {
        return false;
      }
    } else if (!this.hasAddressFilled('ese_anwalt_')) {
      return false;
    }

    return true;
  }

  private vertretungsberechtigterCaseValid(): boolean {
    if (!this.allVertretungsberechtigteFieldsFilled()) {
      return false;
    }

    return (
      !!this.val['ese_vertretungsberechtigte_person_email'] ||
      this.hasAddressFilled('ese_vertretungsberechtigte_person_')
    );
  }

  private hasAddressFilled(prefix: string): boolean {
    return (
      !!this.val[prefix + 'strasse_hausnummer'] &&
      !!this.val[prefix + 'postleitzahl'] &&
      !!this.val[prefix + 'ort']
    );
  }

  private allVertretungsberechtigteFieldsFilled(): boolean {
    return (
      !!this.val['ese_vertretungsberechtigte_person_typ'] &&
      !!this.val['ese_vertretungsberechtigte_person_vorname'] &&
      !!this.val['ese_vertretungsberechtigte_person_nachname']
    );
  }

  private hasAtLeastOneField(prefix: string): boolean {
    return Object.entries(this.val).some(([key, value]) => key.startsWith(prefix) && !!value);
  }
}
